/**
 * Converts the first character to upper case and the rest of the characters to lower case.
 */
export function capitalize(value: string): string {
  const lowercased = value.toLowerCase();
  const [firstLetter, ...rest] = lowercased;
  return `${firstLetter.toUpperCase()}${rest.join('')}`;
}

/**
 * Converts every first character of each word to upper case, words are separated by space and dash.
 */
export function capitalizeEvery(value: string): string {
  let result = '';
  const spaceSplit = value.split(' ');
  result = spaceSplit.map(capitalize).join(' ');
  const dashSplit = value.split('-');
  result = dashSplit.map(capitalize).join('-');
  return result;
}

/**
 * Splits a string into postal code and city
 */
export function splitPostalCodeAndCity(value: string): { postalCode: string; city: string } {
  // See registrationSchemaBuilder.ts -> postalRegex for more details
  const postalCode = value.match(/^[\p{N}\p{L}\u002D]+/u)?.[0] ?? '';
  const city = value.replace(/^[\p{N}\p{L}\u002D]+/u, '').trim();
  return {
    postalCode,
    city,
  };
}
